import React from 'react';
import { getTranslation } from '../../../../utils/translation';
import Status from '../../../shared/Status/Status';
import { renderTerminalsStatusName } from '../../../../utils/render';
import { TERMINAL_STATUSES } from '../../../../constants/enums';

export default function Table(props) {
    const { terminals } = props;

    const getStatusTheme = statusName => {
        switch (statusName) {
            case TERMINAL_STATUSES.active:
                return 'success';
            case TERMINAL_STATUSES.inactive:
                return 'danger';
            default:
                return '';
        }
    };
    return terminals.length ? (
        <table className={'point-table'}>
            <thead>
                <tr align='center'>
                    <th>{getTranslation('terminalsTableColumnsNo')}</th>
                    <th>{getTranslation('terminalsTableColumnsStatus')}</th>
                    <th>{getTranslation('terminalsTableColumnsTerminalCode')}</th>
                    <th>{getTranslation('terminalsTableColumnsCurrentBalance')}</th>
                </tr>
            </thead>
            <tbody>
                {terminals.map((terminal, index) => {
                    const { id, status, terminalCode, currentBalance } = terminal;
                    return (
                        <tr key={id} align='center'>
                            <td className='td-number'>{index + 1}</td>
                            <td>
                                <Status
                                    status={getStatusTheme(status)}
                                    title={renderTerminalsStatusName(status)}
                                />
                            </td>
                            <td>{terminalCode}</td>
                            <td>{currentBalance}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    ) : null;
}
